import React from "react";
import GPTmodule from "./components/Modules/AskGPT";
import DalleModule from "./components/Modules/AskDalle";
//import Logger from "./components/Modules/Logger";
//import CloudUpload from "./components/Modules/CloudUpload";

import "./App.css";

const modules = [
  /*{
    id: 1,
    component: <Logger name="Logger" />,
    style: { gridColumn: "1/6" },
  },*/
  {
    id: 2,
    component: <GPTmodule name="Gpt Module" />,
    style: { gridColumn: "1/4" },
  },
  {
    id: 3,
    component: <DalleModule name="Dalle Module" />,
    style: { gridColumn: "5/6" },
  },
  /*{
    id: 4,
    component: <CloudUpload name="Cloud Upload" />,
    style: { gridColumn: "1/2" },
  },*/
];

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="/logo192.png" alt="egg" className="egg-image" />
        <h1 className="title">Bem-vindo ao Egg!</h1>
        <p className="subtitle">
          Você já ouviu falar do egg.did.lu? É onde todos os projetos se unem em um só lugar - é
          como uma omelete de ideias geniais! 🍳💡
        </p>
      </header>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module.id} style={module.style}>
            <div className="module-item">{module.component}</div>
          </div>
        ))}
      </div>
      {/*<GridLayout className="layout" layout={layout} cols={3} rowHeight={200} width={1600}>
        {modules.map((module) => (
          <div className="module" key={module.id}>
            {module.component}
          </div>
        ))}
        </GridLayout>*/}
    </div>
  );
}

export default App;
